import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import Backend from 'i18next-http-backend'

i18n
  // Load translation using http -> see /public/locales
  .use(Backend)
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Init i18next
  .init({
    debug: true,
    fallbackLng: 'en',
    backend: {
      loadPath: () => {
        const host = window.location.host
        return host.includes('localhost')
          ? '/locales/{{lng}}/{{ns}}.json'
          : './locales/{{lng}}/{{ns}}.json'
      },
      requestOptions: {
        cache: 'no-store',
      },
    },
    interpolation: {
      escapeValue: false,
    },
    ns: 'common',
    defaultNS: 'common',
  })

export default i18n
